(function ClientProfile($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		// var $reservation_container = $("#client-profile-reservations-container");

		$(".client-info-tabs li a").on('click', function loadTabularData()
		{
			var substring_count = 1,
			    row_count       = 0,
			    $tab            = $(this),
			    $tab_value      = $tab.attr("href").substring(substring_count);

			switch ($tab_value) {
				case "client-reservations":
					if ($("#client-profile-reservations-container tr").length === row_count)
					{
						getCompressedReservationData($("#client-profile-reservations-container > input").val());
					}
					break;
				default:
					// nothing happening
			}
		});
	});

	function getCompressedReservationData(reservation_ids) {
		Adzuki.Ajax.get('/Clients/_compressedReservationData/' + reservation_ids)
		.then(function loadDataSuccess(response) {
			$("#client-profile-reservations-container").html(response);
		})
		.catch(function error(err) {
			console.log(err);
		});
	}

	Adzuki.onload('Clients/bookingInfo', function onload() {
		// This piece of code will have the page scrolling down to the where2next destinations panel.
		if ($('#where2next-destinations-box').length === 1) {
			$('html, body').animate({
			    scrollTop: $("#where2next-destinations-box").offset().top - 60
			}, 1000);
		}

		$('.deposit-details').click(function showDepositDetail(e) {
			var model_id    = $(this).data("id"),
			    model       = $(this).data("model"),
			    modal_title = $(this).data("modal-header");

			e.preventDefault();

			$modal.find('.modal-title').text(modal_title);
			$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading...');
			$modal.modal('show');

			Adzuki.Ajax.get('/Clients/futureDepositDetails/' + model_id + '/' + model)
			.then(function success(data) {
				$modal.find('.modal-body').html(data);
			});
		});
	});
}(jQuery, window.Adzuki || {}));